

$('.single-slider .slide-list').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  slidesToShow: 1,
  adaptiveHeight: true
});



$('.review-section .review-left-itam').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});



$('.world-of-metals-section .world-of-metals-itam-main').slick({
  dots:false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});

$('.recommand-slider').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(document).on("click",".qtybox .btnqty",function() {
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
});





$(document).ready(function() {
  // Default active on first box
  $('.shopby_category_box').first().addClass('active');

  // Click on plus button
  $('.cat_plush_btn').on('click', function(e) {
    e.preventDefault(); // Prevent link click
    let parentBox = $(this).closest('.shopby_category_box');
    
    // Remove active from all, add to clicked one
    $('.shopby_category_box').removeClass('active');
    parentBox.addClass('active');
  });
});



$('.reviewBox').slick({
  centerMode: true,
   centerPadding: '0px',
  dots: false,
  arrows:true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
         centerMode: false,
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight:true,
      }
    }
  ]
});

if ($(window).width() <1201) {
$('.feacture_coll_inner>.grid').slick({
  dots: false,
  arrows:true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
}